__turbopack_context__.v({
  "banner": "MainRecommendationBlock-module-scss-module__El1n5a__banner",
  "banner-cell": "MainRecommendationBlock-module-scss-module__El1n5a__banner-cell",
  "carousel-cell": "MainRecommendationBlock-module-scss-module__El1n5a__carousel-cell",
  "count-1": "MainRecommendationBlock-module-scss-module__El1n5a__count-1",
  "count-2": "MainRecommendationBlock-module-scss-module__El1n5a__count-2",
  "is-centered": "MainRecommendationBlock-module-scss-module__El1n5a__is-centered",
  "main-banners": "MainRecommendationBlock-module-scss-module__El1n5a__main-banners",
  "section-link": "MainRecommendationBlock-module-scss-module__El1n5a__section-link",
  "section-links": "MainRecommendationBlock-module-scss-module__El1n5a__section-links",
  "sub-header-cards": "MainRecommendationBlock-module-scss-module__El1n5a__sub-header-cards",
  "wrapper": "MainRecommendationBlock-module-scss-module__El1n5a__wrapper",
});
